module.exports = __webpack_public_path__ + "img/car-B.00ebd372.jpg";